import {
  ContentCopy,
  KeyboardDoubleArrowDown,
  KeyboardDoubleArrowUp,
} from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import Convert from "ansi-to-html";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { showSnackbar } from "./../../redux/actions/commonAction";
import { useStyles } from "./styles";

const AppConsole = ({ logs }) => {
  const dispatch = useDispatch();
  const consoleRef = useRef(null);
  const classes = useStyles();
  const [content, setContent] = useState("");

  useEffect(() => {
    if (logs) {
      // applying html colors instead of ANSI streams
      setContent(new Convert().toHtml(logs));
    }
  }, [logs]);

  useEffect(() => {
    goToBottom();
    //eslint-disable-next-line
  }, []);

  const goToTop = () => {
    if (consoleRef.current) {
      consoleRef.current.scrollTop = 0;
    }
  };

  const goToBottom = () => {
    if (consoleRef.current) {
      consoleRef.current.scrollTop = consoleRef.current.scrollHeight;
    }
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(logs);
      dispatch(
        showSnackbar({
          message: "Copied to clipboard",
          severity: "info",
          open: true,
        })
      );
    } catch (error) {
      console.error("Error copying to clipboard:", error);
    }
  };

  const btnProps = {
    size: "small",
    variant: "outlined",
    sx: {
      color: (theme) => theme.palette.common.white,
      border: (theme) => `1px solid ${theme.palette.common.white}`,
    },
  };

  return (
    <Box>
      <Box className={classes.actions}>
        <Button
          {...btnProps}
          onClick={copyToClipboard}
          startIcon={<ContentCopy />}
        >
          Copy Raw
        </Button>
        <Button
          {...btnProps}
          onClick={goToTop}
          startIcon={<KeyboardDoubleArrowUp />}
        >
          Top
        </Button>
        <Button
          {...btnProps}
          onClick={goToBottom}
          startIcon={<KeyboardDoubleArrowDown />}
        >
          Bottom
        </Button>
      </Box>
      <Box ref={consoleRef} className={classes.consoleBody}>
        <pre>
          <code dangerouslySetInnerHTML={{ __html: content }} />
        </pre>
      </Box>
    </Box>
  );
};

export default AppConsole;
